// src/components/VanityResolver.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { ClipLoader } from 'react-spinners';
import VideoLanding from './VideoLanding';
import { getPublicProfile } from '../utils/publicProfile';

function VanityResolver() {
  const { vanityId } = useParams();
  const [resolvedData, setResolvedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolveVanity = async () => {
      if (!vanityId) {
        setLoading(false);
        return;
      }

      console.log(`VanityResolver: Attempting to resolve "${vanityId}"`);

      try {
        const lookupId = vanityId.toLowerCase().trim();
        const vanityDocRef = doc(db, 'vanity_urls', lookupId);
        const vanitySnap = await getDoc(vanityDocRef);

        if (!vanitySnap.exists()) {
          setError('not-found');
          setLoading(false);
          return;
        }

        const { uid } = vanitySnap.data();
        const profileData = await getPublicProfile(uid);

        if (!profileData) {
          setError('not-found');
          setLoading(false);
          return;
        }

        if (!profileData.primaryVideoId) {
          setError('no-primary');
          setLoading(false);
          return;
        }

        setResolvedData({
          userId: uid,
          videoId: profileData.primaryVideoId
        });
      } catch (err) {
        console.error('VanityResolver: Error resolving vanity URL:', err);
        setError('error');
      } finally {
        setLoading(false);
      }
    };

    resolveVanity();
  }, [vanityId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <ClipLoader size={50} color="#123abc" loading={loading} />
      </div>
    );
  }

  if (error === 'not-found' || !resolvedData) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Profile Not Found</h2>
        <p className="text-gray-600 mb-6">The vanity link "reelintro.com/{vanityId}" hasn't been claimed yet.</p>
        <a href="/" className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700">
          Back to ReelIntro
        </a>
      </div>
    );
  }

  if (error === 'no-primary') {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Almost Ready!</h2>
        <p className="text-gray-600 mb-6">This user has claimed their link but hasn't selected a primary video to display yet.</p>
        <a href="/" className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700">
          Back to ReelIntro
        </a>
      </div>
    );
  }

  return <VideoLanding userId={resolvedData.userId} videoId={resolvedData.videoId} />;
}

export default VanityResolver;
